// @givmo/app-charity — carrying a typed email across the sign-in ⇄ create cross-links.
//
// The unified door cannot probe account existence (Firebase blocks enumeration), so a caller can
// land on the wrong email form and cross to the other. Making them retype the address they just
// typed converts a one-click recovery into a do-over — so the leaving form stashes it and the
// arriving form takes it.
//
// sessionStorage, not the URL: a `?email=` search param would put a personal address into browser
// history and Hosting access logs (this repo's PII-safe posture), and router state does not survive
// the router's search-driven navigation idiom here. Per-tab, consumed on read, gone on tab close.
// Every access is inside try/catch — sessionStorage can throw on ACCESS, not just write, in some
// privacy modes and partitioned contexts (see agent_docs/auth.md on the passkey probe), and a
// storage fault must cost only the prefill, never the screen.

const KEY = 'givmo-charity-auth-email-handoff';

/** Stash a typed email for the form the caller is crossing to. Blank stashes nothing. */
export function stashEmailHandoff(email: string): void {
  const trimmed = email.trim();
  if (trimmed.length === 0) return;
  try {
    sessionStorage.setItem(KEY, trimmed);
  } catch {
    // Storage unavailable — the caller retypes; nothing else changes.
  }
}

/** Take (and clear) a stashed email. Returns '' when there is none or storage is unavailable. */
export function takeEmailHandoff(): string {
  try {
    const value = sessionStorage.getItem(KEY) ?? '';
    sessionStorage.removeItem(KEY);
    return value;
  } catch {
    return '';
  }
}
